import * as config from '../helpers/config';

export default function useFeatToogle(prop) {
  return config.get(`featureToggle.${prop}`);
}
